import React from "react";

interface OMSpinnerProps {
  wrapperClassName?: string;
  spinnerClassName?: string;
  text?: string;
}
export const OMSpinner = ({ wrapperClassName, spinnerClassName, text }: OMSpinnerProps) => (
  <div
    className={
      wrapperClassName
        ? wrapperClassName
        : "flex justify-center items-center h-screen flex-col gap-4"
    }>
    <div
      className={
        spinnerClassName
          ? spinnerClassName
          : "animate-spin rounded-full h-24 w-24 border-t-4 border-ominimo-900"
      }></div>
    {text && <p className="text-gray-376">{text}</p>}
  </div>
);
